// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectPurposeOfValuationQueryResult, selectPurposeOfValuationsPageLoading, selectPurposeOfValuationsShowInitWaitingMessage} from '../_selectors/purpose-of-valuation.selectors';

export class PurposeOfValuationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectPurposeOfValuationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPurposeOfValuationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPurposeOfValuationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
